import { gql } from '@apollo/client';

const Fragments = {
  documentType: gql`
    fragment documentType on DocumentType {
      id
      code
      name
    }
  `
};

export default Fragments;
